export type PerKidOutcome = {
  succeeded: string[];
  failed: string[];
  firstError?: any;
};

export async function runForEachKid(
  kidsIds: string[],
  task: (kidsId: string) => Promise<void>,
): Promise<PerKidOutcome> {
  const succeeded: string[] = [];
  const failed: string[] = [];
  let firstError: any;

  for (const kidsId of kidsIds) {
    try {
      await task(kidsId);
      succeeded.push(kidsId);
    } catch (e: any) {
      failed.push(kidsId);
      if (!firstError) {
        firstError = e;
      }
    }
  }

  return { succeeded, failed, firstError };
}

export function describeOutcome(outcome: PerKidOutcome): string {
  const total = outcome.succeeded.length + outcome.failed.length;

  if (!outcome.failed.length) {
    return 'Saved successfully!';
  }

  if (!outcome.succeeded.length) {
    return String(outcome.firstError?.response?.data?.message || 'Nothing could be saved.');
  }

  return `Saved for ${outcome.succeeded.length} of ${total} students. ${outcome.failed.length} could not be saved.`;
}

export default runForEachKid;
